export default __webpack_public_path__ + "static/media/chauferservice.f8ede21f.jpg";